import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FilestackModule } from '@filestack/angular';
import { ChartModule } from 'primeng/chart';


@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ChartModule,
    DragDropModule,
    ScrollingModule,
    CKEditorModule,
    FilestackModule,
  ],
  exports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ChartModule,
    DragDropModule,
    CKEditorModule,
    ScrollingModule,
    FilestackModule,
  ],
  providers: [],
  declarations: []
})
export class SharedModule {
}
